import React from 'react';
import TableHeader from '../../components/table-header';
import ResultItem from './result-item';
import Page from '@/components/business/games/page';
import {ColorGetLatestContentResponse, getLatest} from '../../color-service';
import theme from '@/style';
import Spin from '@/components/basic/spin';
import NoData from '@/components/basic/error-pages/no-data';

const pageSize = 10;

const Result = ({
  configId,
  isActive = false,
  refreshCode = 0,
}: {
  configId?: number;
  refreshCode?: number;
  isActive?: boolean;
}) => {
  const [total, setTotal] = React.useState(0);
  const [firstLoad, setFirstLoad] = React.useState(true);
  const [list, setList] = React.useState<ColorGetLatestContentResponse[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [initPage, setInitPage] = React.useState(1);
  // configId: number;
  // pageNo: number;
  // pageSize: number;

  const getList = async (id: number, page: number = 1) => {
    try {
      setLoading(true);
      const res = await getLatest({
        configId: id,
        pageNo: page,
        pageSize,
      });
      if (res) {
        setTotal(res.totalSize);
        setList(res.content);
      }
    } finally {
      setLoading(false);
      setFirstLoad(false);
    }
  };

  React.useEffect(() => {
    if (configId && isActive) {
      getList(configId).then();
    }
  }, [configId, isActive]);

  React.useEffect(() => {
    if (refreshCode && isActive && configId) {
      getList(configId).then();
      setInitPage(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshCode]);

  return (
    <Spin loading={firstLoad || loading} style={[theme.flex.flex1]}>
      <TableHeader headers={['issue', 'number', 'color']} />
      {!firstLoad && !loading && list && list.length === 0 ? <NoData /> : null}
      {list.map((item, index) => (
        <ResultItem
          key={index}
          issueNum={item.issueNo}
          index={index}
          color={item.colorResult}
          digit={item.digitResult}
        />
      ))}
      {list.length > 0 ? (
        <Page
          page={initPage}
          total={total}
          pageSize={pageSize}
          onPageChange={p => {
            if (configId) {
              setInitPage(p);
              getList(configId, p).then();
            }
          }}
        />
      ) : null}
    </Spin>
  );
};

export default React.memo(Result);
